/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "#/lib/social-signal-api-client.ts"
import type {
  RequestConfig,
  ResponseErrorConfig,
} from "#/lib/social-signal-api-client.ts"
import type {
  LookupUserIdMutationRequest,
  LookupUserIdMutationResponse,
  LookupUserId400,
  LookupUserId401,
  LookupUserId404,
} from "../types/LookupUserId.ts"
import {
  lookupUserIdMutationResponseSchema,
  lookupUserIdMutationRequestSchema,
} from "../zod/lookupUserIdSchema.ts"

function getLookupUserIdUrl() {
  const res = { method: "POST", url: `/users/lookup` as const }
  return res
}

/**
 * @summary Look up a user's ID by username, email, or phone number
 * {@link /users/lookup}
 */
export async function lookupUserId(
  data?: LookupUserIdMutationRequest,
  config: Partial<RequestConfig<LookupUserIdMutationRequest>> & {
    client?: typeof fetch
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = lookupUserIdMutationRequestSchema.parse(data)

  const res = await request<
    LookupUserIdMutationResponse,
    ResponseErrorConfig<LookupUserId400 | LookupUserId401 | LookupUserId404>,
    LookupUserIdMutationRequest
  >({
    method: "POST",
    url: getLookupUserIdUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return lookupUserIdMutationResponseSchema.parse(res.data)
}
